import { render, staticRenderFns } from "./PrivacySet.vue?vue&type=template&id=1371d450&scoped=true"
import script from "./PrivacySet.vue?vue&type=script&lang=js"
export * from "./PrivacySet.vue?vue&type=script&lang=js"
import style0 from "./PrivacySet.vue?vue&type=style&index=0&id=1371d450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371d450",
  null
  
)

export default component.exports